import { get } from 'svelte/store';

import {
    MSI_REWARD_DEFAULT_UI_TYPE,
    MSI_REWARD_PAGE_TYPE,
    MSI_REWARD_PUB_PAGE,
    type MsiRewardPageType
} from '../constants/pageType';
import { msiRewardPageType } from '../store/index';

export const initMsiRewardPageType = (type: MsiRewardPageType) => {
    msiRewardPageType.set(type);

    if (typeof document !== 'undefined') {
        document.documentElement.dataset.msiRewardPage = type;
        document.body.classList.add('msi-reward-page-card-msi');
    }
};

export const getMsiRewardPageType = (): MsiRewardPageType =>
    get(msiRewardPageType);

export const isMsiPage = () =>
    getMsiRewardPageType() === MSI_REWARD_PAGE_TYPE.CARD_MSI;

export const resolvePubPage = () => MSI_REWARD_PUB_PAGE[getMsiRewardPageType()];

export const resolveDefaultUiType = () =>
    MSI_REWARD_DEFAULT_UI_TYPE[getMsiRewardPageType()];

/** card-msi：cardLogin/fifa + 领奖 */
export const usesFifaCardLogin = () => isMsiPage();

export const usesLegacyLoginFlow = () => false;

export const usesEndLoginLayout = () => false;
